import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { ClientDataInitializerService } from 'src/app/core/services/authentication/client-data-initializer.service';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false
})
export class PageHeaderComponent
  extends BasePageComponent
  implements OnInit, OnDestroy
{
  //#region properties

  @Input('title') input_title: string;
  @Input('loading') input_loading: boolean;
  @Input('isForm') input_isForm: boolean;
  @Input('isShowForm') input_isShowForm: boolean;
  @Input('isAddBtnWithLoading') input_isAddBtnWithLoading: boolean;

  //buttons
  @Input('showDefaultBtns') input_showDefaultBtns: boolean = true;
  @Input('showAddBtn') input_showAddBtn: boolean = true;
  @Input('showAddBtnOnlyForSuperAdmin')
  input_showAddBtnOnlyForSuperAdmin: boolean = false;
  @Input('showRefreshBtn') input_showRefreshBtn: boolean = true;
  @Input('showBackBtn') input_showBackBtn: boolean = true;
  @Input('showAuditBtn') input_showAuditBtn: boolean = true;
  @Input('showHelpBtn') input_showHelpBtn: boolean = true;
  @Input('showFormAuditBtn') input_showFormAuditBtn: boolean = false;
  @Input('showLoadingBar') input_showLoadingBar: boolean = true;
  @Input('showBorderBottom') input_showBorderBottom: boolean = true;
  @Input('showTitle') input_showTitle: boolean = true;
  @Input('titleClass') input_titleClass: string = 'tw-dir-ltr';
  @Input() display: string = '';

  //outputs
  @Output('onAdd') output_onAdd = new EventEmitter<boolean>();
  @Output('onBack') output_onBack = new EventEmitter<boolean>();
  @Output('onRefresh') output_onRefresh = new EventEmitter<boolean>();
  @Output('onShowAudit') output_onShowAudit = new EventEmitter<boolean>();
  @Output('onShowHelp') output_onShowHelp = new EventEmitter<boolean>();
  @Output('onShowFormAudit') output_onShowFormAudit =
    new EventEmitter<boolean>();

  addBtnLoading: boolean = true;

  //#endregion

  constructor(
    // protected permissionService: PermissionService,
    // protected elementRef: ElementRef,
    // protected loggerService: LoggerService,
    protected clientDataService: ClientDataInitializerService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.input_isShowForm) this.addBtnLoading = false;
  }

  onAdd() {
    if (this.addBtnLoading) return;
    if (this.input_isAddBtnWithLoading) this.addBtnLoading = true;

    this.output_onAdd.emit(true);
  }
  onBack() {
    this.output_onBack.emit(true);
  }
  onReset() {
    this.output_onRefresh.emit(true);
  }
  onShowAuditPage() {
    this.output_onShowAudit.emit(true);
  }
  onShowFormAuditPage() {
    this.output_onShowFormAudit.emit(true);
  }
  onShowHelpPage() {
    this.output_onShowHelp.emit(true);
  }

  //#endregion
}
